import * as cx from "classnames/bind";
import {
  Button,
  ButtonLink,
  Container,
  OrderSummary,
  Section,
} from "components";
import { useCart } from "hooks";
import { HomeLayout } from "layouts";
import Image from "next/legacy/image";
import Link from "next/link";
import Head from "next/head";
import { useRouter } from "next/router";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useState } from "react";
import { push } from "@socialgouv/matomo-next";
import s from "styles/Cart.module.scss";

export default function Home({ csrfToken }) {
  const [isOpen, setOpen] = useState(false);
  const handleOpen = () => {
    setOpen(!isOpen);
  };

  const { t } = useTranslation();

  const router = useRouter();
  const { cart, setQuantity } = useCart();
  const currency = cart.currency || "nok";

  const goToCheckout = async () => {
    push(["trackEvent", "Ecommerce", "Go to checkout", "go to checkout"]);
    router.push("/checkout");
  };

  return (
    <>
      <Head>
        <meta name="robots" content="noindex, follow" />
      </Head>
      <HomeLayout className={cx("Checkout", s.Cart)}>
        <div className={cx("checkoutContent", s.cartContent)}>
          <div className={cx(s.cSection, s.leftContent)}>
            <div className={cx(s.cHeader)}>
              <h2 className="Heading__sub">{t("Your shopping cart")}</h2>
            </div>
            <div className={cx(s.cProductList)}>
              {cart.items.map((item) => {
                const price = item.product.prices[currency];
                return (
                  <div key={item.product.id} className={cx(s.cProductItem)}>
                    <div className={cx(s.cProductImg)}>
                      <Link href="/q-kit" target="_blank">
                        <img alt="" src="/img/kit1.jpg" />
                      </Link>
                    </div>
                    <div className={cx(s.cProductInfo)}>
                      <h3 className="Bold Black">
                        <Link href="/q-kit" target="_blank">
                          {item.product.name}
                        </Link>
                      </h3>
                      <p>
                        {t("Quantity")}:
                        <button
                          onClick={() => {
                            setQuantity(item.product, item.quantity - 1);
                          }}
                        >
                          <img alt="" src="/img/icons/minus-square-light.svg" />
                        </button>
                        <span>{item.quantity || 1}</span>
                        <button
                          onClick={() => {
                            setQuantity(item.product, item.quantity + 1);
                          }}
                        >
                          <img alt="" src="/img/icons/plus-square-light.svg" />
                        </button>
                      </p>
                      <p>
                        <a
                          className="warning"
                          onClick={() => {
                            setQuantity(item.product, 0);
                          }}
                        >
                          {t("Remove")}
                        </a>
                      </p>
                    </div>
                    <div className={cx(s.cProductPrice)}>
                      <p className={cx(s.cPrice)}>
                        {item.quantity > 1 ? `${item.quantity} * ` : ""}
                        {price.unit_amount / 100}
                        &nbsp;
                        <span className="cur">
                          {price.currency.toUpperCase()}
                        </span>
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className={cx(s.cSection, s.rightContent)}>
            <div className={cx(s.cHeader)}>
              <h2 className="Heading__sub">{t("Your order")}</h2>
            </div>
            <OrderSummary />
            <div
              className="Button Primary Full text-center mt18"
              onClick={goToCheckout}
              id="btn_checkout"
            >
              {t("Go to Checkout")}
            </div>
          </div>
        </div>
      </HomeLayout>
    </>
  );
}

export const getStaticProps = async ({ locale }) => ({
  props: {
    ...(await serverSideTranslations(locale)),
  },
});
